import { useState, useEffect } from "react";
import { fetchDepartments, fetchTowns } from "../api/locationApi";

export const useLocation = (selectedDepartment, isOpen) => {
  const [departments, setDepartments] = useState([]);
  const [towns, setTowns] = useState([]);
  const [loading, setLoading] = useState(false);

  // cargar departamentos solo cuando el modal esté abierto
  useEffect(() => {
    if (isOpen) {
      setLoading(true);
      fetchDepartments()
        .then(setDepartments)
        .finally(() => setLoading(false));
    }
  }, [isOpen]);

  // cargar municipios al cambiar de departamento
  useEffect(() => {
    if (selectedDepartment) {
      setLoading(true);
      fetchTowns(selectedDepartment)
        .then(setTowns)
        .finally(() => setLoading(false));
    } else {
      setTowns([]);
    }
  }, [selectedDepartment]);

  return { departments, towns, loading };
};
